import {frequencyToTranspose, equalTemperment} from './utils.js';
import Tone from 'tone';

export const getTranspose = (t, scale, referencePitch=262, lazy) => {
    referencePitch = new Tone.Frequency(referencePitch);
    // figure out what octave where in
    
    let octave = Math.floor(t / 12);
    let offset = t < 0 ? (12 - (Math.abs(t) % 12)) % 12 : t % 12;
    let scaleNote = lazy(scale[Math.floor(scale.length * offset / 12.0)]);
    // now we know which note of the scale
    
    let octavedNote = referencePitch.transpose(octave * 12)._val;
    let transpose = frequencyToTranspose(octavedNote * scaleNote);
    return transpose;
    // so we have to put it together
};

